module.exports = __webpack_public_path__ + "static/media/sg15tj0.931907ff.png";